module.exports = __webpack_public_path__ + "static/media/collection-statement-life-of-the-party.1f7a72bf.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/collection-statement-life-of-the-party.pdf
// module id = 654
// module chunks = 0